import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { Region } from 'src/app/shared/models/dtos/region/region';
import { AdministratorDTO } from 'src/app/shared/models/dtos/responses/administrator-dto/administrator-dto';
import { ProfileMenuItems } from 'src/app/shared/models/profile-menu-items/profile-menu-items';

@Component({
  selector: 'app-header-bar-desktop',
  templateUrl: './header-bar-desktop.component.html',
  styleUrls: ['./header-bar-desktop.component.scss'],
})

/**
 * Displays header bar for home page (desktop)
 */
export class HeaderBarDesktopComponent implements OnInit, OnDestroy {
  date = new Date();
  admin?: AdministratorDTO;
  currentRegion?: Region;
  alt = 'uploaded-image-alt';
  @Input() profileMenuItems = new ProfileMenuItems();
  loading = true;
  private readonly subsink = new Subscription();

  /**
   * @constructor
   */
  constructor(
    private readonly authenticatedUserService: AuthenticatedUserService,
    public translationService: TranslationService
  ) {}

  /**
   * On init
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.profileMenuItems);
    this.subsink.add(
      this.authenticatedUserService.admin$.subscribe((info) => {
        this.admin = info;
        this.loading = false;
      })
    );
    this.subsink.add(
      this.authenticatedUserService.currentRegion$.subscribe((region) => {
        this.currentRegion = region;
        this.loading = false;
      })
    );
  }

  /**
   * cleans up resources
   */
  ngOnDestroy() {
    this.subsink.unsubscribe();
  }
}
